import '../forms/serialize-object.js';

/**
 * Shared handler for widget-admin "Save Settings" buttons.
 *
 * @param {object} config
 * @param {string} config.buttonSelector   e.g. '#banner_save'
 * @param {string} config.formSelector     e.g. '#bannerSettings'
 * @param {string} config.ajaxUrl          POST endpoint
 * @param {string} config.successMessage   Toast shown on success
 * @param {string} config.errorMessage     Toast shown on failure
 * @param {boolean} [config.alertOnFailData]  If true, alert(data) on non-"1"
 */
export function initWidgetAdminSave(config) {
  $(config.buttonSelector).on('click', function (e) {
    e.preventDefault();
    var settings = $(config.formSelector).serializeObject();

    $.ajax({
      type: 'POST',
      url: config.ajaxUrl,
      data: { data: settings },
      success: function (data) {
        if (data === '1') {
          displayToastrAlert('success', config.successMessage, true);
          $('#settings').slideUp();
        } else {
          if (config.alertOnFailData) {
            alert(data);
          }
          displayToastrAlert('error', config.errorMessage, true);
        }
      },
      error: function () {
        displayToastrAlert('error', config.errorMessage, true);
      },
    });
  });
}
